/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';
import MegaMenuListItem from '../MegaMenuListItem';
import s from './MegaMenuSubcategory.module.scss';

function MegaMenuSubcategory({ className, parentCategoryLabel, subCategories }) {
  const groupByColumnType = (arr) => {
    const obj = {};
    const columnTypeMap = arr.reduce((r, a) => {
      obj[a.columnType] = obj[a.columnType] || [];
      obj[a.columnType].push(a);
      return obj;
    }, Object.create(null));
    return columnTypeMap;
  };

  const groupedColumns = groupByColumnType(subCategories);

  return (
    <>
      {Object.keys(groupedColumns).map((key) => (
        <ol key={key} className={cn(className, s.container)} aria-label={`${parentCategoryLabel} Department`}>
          {groupedColumns[key].map(({
            label: subCategoryLabel, columnType, links, id: idLevelTwo,
          }) => (
            <li
              className={s.item}
              data-column-type={columnType}
              key={idLevelTwo}
              role="none"
            >
              <MegaMenuListItem className={s.label} linkLevel={2} role="heading">
                {subCategoryLabel}
              </MegaMenuListItem>
              <ol className={s.links}>
                {links.map(({ title: tertiaryTitle, url, id: idLevelThree }) => (
                  <li key={idLevelThree} className={s.linkWrapper} role="none">
                    <MegaMenuListItem className={s.link} url={url} linkLevel={3}>
                      {tertiaryTitle}
                    </MegaMenuListItem>
                  </li>
                ))}
              </ol>
            </li>
          ))}
        </ol>
      ))}
    </>
  );
}


MegaMenuSubcategory.propTypes = {
  className: PropTypes.string,
  parentCategoryLabel: PropTypes.string,
  subCategories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      columnType: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
};

export default React.memo(MegaMenuSubcategory);
